import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IOperationResultNoValue, ISatisfactionSurveyResponse } from '../../surveys/models/Api';

export const useClientTrackSatisfactionResponseClickThroughMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data?: ISatisfactionSurveyResponse) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({ response, accessToken }: { response: ISatisfactionSurveyResponse; accessToken: string }) => {
			return apiClient.post<ISatisfactionSurveyResponse>(
				`survey/satisfaction/response/${response.id}/reviewClick?token=${accessToken}`,
				response
			);
		},
		onError,
		onSuccess,
	});
};
